import { useEffect } from 'react';
import { buildGoogleFontHref } from '@/config/googleFonts';

/**
 * Loads a whitelisted Google font by appending its stylesheet to the document head.
 * A family outside the whitelist is ignored and the form keeps the default font.
 *
 * The link is left in place on unmount: the font stays cached and removing it would
 * make the text flash back to the fallback.
 *
 * @param {string} [fontFamily] - The family name from `layout.typography.fontFamily`
 */
export const useGoogleFont = (fontFamily) => {
  useEffect(() => {
    const href = buildGoogleFontHref(fontFamily);
    if (!href || document.querySelector(`link[href="${href}"]`)) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }, [fontFamily]);
};
